import { atom } from 'recoil';

export const shopModalAtom = atom<boolean>({
  key: 'shopModalAtom',
  default: false,
});
